import { useDestinationsContext } from '../../../../../Contexts/DestinationsContext'
import { getMultiStoreOptions } from '../../../../../util'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import React from 'react'

export const MultiTargetSwitcher = ({ container, targetIndex, changeTargetLocation, index }) => {
  const { orderDestinations } = useDestinationsContext()
  const multiOptions = getMultiStoreOptions(
    orderDestinations,
    container.product_name,
    container.targets.map((c) => c.location_name)
  )

  const OtherDestinationMenu = () => {
    return (
      <Menu>
        {multiOptions.map((m, i) => {
          const tankId = m.tanks.find((t) => t.product === container.product_name)?.tank_id
          return (
            <Menu.Item key={i}>
              <a type='link' onClick={() => changeTargetLocation(index, targetIndex, m.store_number, tankId)}>
                {m.store_number}
              </a>
            </Menu.Item>
          )
        })}
      </Menu>
    )
  }

  return (
    <>
      {multiOptions.length > 0 ? (
        <Dropdown overlay={<OtherDestinationMenu />}>
          <a className='ant-dropdown-link' onClick={(e) => e.preventDefault()}>
            {container.targets[targetIndex].location_name} <DownOutlined />
          </a>
        </Dropdown>
      ) : (
        <p style={{ marginTop: 0 }} className='multi-target-label'>
          {container.targets[targetIndex].location_name}{' '}
        </p>
      )}
    </>
  )
}
